import type { InitAppResponse } from "@hz/common/api-types/init";
import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "./baseQuery";
import { Tags as T } from "./tags";

export const Tags = T;

type InitParams = {
  boardId: number;
  itemId: number;
};

export const api = createApi({
  reducerPath: "apiSlice",
  baseQuery: baseQuery,
  endpoints: (build) => ({
    init: build.query<InitAppResponse, InitParams>({
      query: ({ boardId, itemId }) => ({
        url: `/init/${boardId}/${itemId}`,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      providesTags: [{ type: Tags.Init }],
    }),
  }),
  tagTypes: [
    Tags.Init,
    Tags.DataMapping,
    Tags.Invoices,
    Tags.Invoice,
    Tags.Customers,
    Tags.ConnectionStatus,
    Tags.Permissions,
    Tags.Products,
    Tags.TaxCodes
  ],
});

export type ApiEndpoints = typeof api.endpoints;
